module.exports = __webpack_public_path__ + "static/media/moving.eff08534.svg";